export default __webpack_public_path__ + "static/playtika.15033-16d0540bcfa84270afbae7e444153e95.svg";